module.exports = __webpack_public_path__ + "static/img/6jiaoxue.e8cd0be0.jpg";